import React from 'react';
import * as actions from '../actions';
import componentServices from '../componentServices';
import valueFilters from '../valueFilters';

export default class ResetPassword extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = { email: '', password: '', confirmed: '' };

		this.handleChange = this.handleChange.bind(this);
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.handleResetClick = this.handleResetClick.bind(this);
	}

	handleChange (e) {
		const name = e.target.name;
		const newVal = e.type === 'change' ? e.target.value : valueFilters.clean(e.target.value);
		const patch = {};

		patch[name] = newVal;

		this.setState(patch);
	}

	handleKeyPress (e) {
		if (e.which === 13) {
			e.preventDefault();
			this.reset();
		}
	}

	handleResetClick (e) {
		e.preventDefault();
		this.reset();
	}

	reset () {
		const { email, password, confirmed } = this.state;

		actions.clearAlerts();
		if (!email) {
			actions.pushAlert({ type: 'error', message: 'Please enter an email address.' });
			return;
		}
		if (!password || !confirmed) {
			actions.pushAlert({ type: 'error', message: 'Please enter a Password and Confirmation.' });
			return;
		}
		if (password !== confirmed) {
			actions.pushAlert({ type: 'error', message: 'Passwords do not match.' });
			return;
		}
		actions.resetPassword({
			email: email,
			token: componentServices.routeParams.token,
			password: password
		});
	}

	render () {
		const { email, password, confirmed } = this.state;

		return (
			<div>
				<section>
					<div onKeyPress={this.handleKeyPress}>
						<h1>Update Your Password</h1>
						<p><input type="text" placeholder="Email Address" autoCapitalize="none" autoCorrect="off" name="email" value={ email } onChange={ this.handleChange } onBlur={ this.handleChange } /></p>
						<p><input type="password" placeholder="Enter a New Password" name="password" value={ password } onChange={ this.handleChange } onBlur={ this.handleChange } /></p>
						<p><input type="password" placeholder="Confirm Password" name="confirmed" value={ confirmed } onChange={ this.handleChange } onBlur={ this.handleChange } /></p>
						<button className="action" onClick={this.handleResetClick}><span>Update</span></button>
					</div>
				</section>
			</div>
		);
	}
}